import React from "react";
import styles from "./Dropdown.module.css";
import { IDropDownDataProps } from "../../../../types/genericComponents";
import Image from "next/image";
import HTMLReactParser from "html-react-parser/lib/index";
import Link from "next/link";

const Dropdown = ({
  dropDownData,
  dropDownActions,
}: {
  dropDownData: IDropDownDataProps[];
  dropDownActions: Function[];
}) => {  
  return (
    <div className={styles.root}>
      {dropDownData.map((content: IDropDownDataProps, index: number) => {
        return (
          <Link
            className={styles.contentContainer}
            href={content.link || "/"}
            target={content.outside ? "_blank" : ""}
          >
            <div className={styles.imageContainer}>
              <Image
                src={content.img}
                alt={content.imgAlt || content.title}
                fill
                objectFit="contain"
              />
            </div>
            <div className={styles.textContainer}>
              <div className={styles.title}>{content.title}</div>
              <div className={styles.desc}>{content.desc}</div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default Dropdown;
